// Person detail modal open/close helpers — registered via
// context.functions so any element can dispatch them with:
//   el.call('openPersonDetailModal', person)   // person object
//   el.call('closePersonDetailModal')
//
// Migrated 2026-06-01 from `root.update({ _personDetail: person })` to
// a @symbo.ls/windows custom-template layer. `root._personDetail` plus
// the related `_personDetailShowAdd` / `_personDetailAddTeamId` fields
// stay as data carriers — the body's reactive reads on them are
// unchanged.

const PERSON_DETAIL_LAYER_ID = 'person-detail'

const _rootState = (el) =>
  el?.state?.root || el?.getRoot?.()?.state?.root || el?.getRoot?.()?.state || null

export function openPersonDetailModal(person) {
  if (!person) return
  const root = _rootState(this)
  if (!root) return
  root.update({
    _personDetail: person,
    _personDetailShowAdd: false,
    _personDetailAddTeamId: null
  })
  // MODAL-X-OVERFLOW-1: openCustomModal supplies a safe default maxHeight
  // so the Close X can't be pushed off-screen by tall content / a short
  // viewport.
  //
  // WS-MODAL-X-HORIZONTAL-OVERFLOW-1: window WIDTH is the layer's job, not
  // the body's. The descriptor sizes ModalWindow (ModalLayer.js reads
  // `width` / `maxWidth` through walkToLayer) so the window caps at the
  // viewport; the body then fills 100% of that slot. Before this the body
  // carried `width: 'I'` inside a default-'H' window with
  // `overflow: 'visible'`, so the body — and the ModalHeader Close X at its
  // right edge — painted OUTSIDE the window and past the viewport.
  this.call('openCustomModal', {
    id: PERSON_DETAIL_LAYER_ID,
    width: 'I',
    maxWidth: '90vw',
    content: { extends: 'PersonDetailModal' }
  })
}

export function closePersonDetailModal() {
  const root = _rootState(this)
  root?.update({
    _personDetail: null,
    _personDetailShowAdd: false,
    _personDetailAddTeamId: null
  })
  this.call('closeModal', PERSON_DETAIL_LAYER_ID)
}
